import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AddProjectLayer from "../components/AddProjectLayer";

const AddProjectPage = () => {
  return (
    <>
      <Breadcrumb title="Add Project" />
      <AddProjectLayer />
    </>
  );
};

export default AddProjectPage;
